module.exports = __webpack_public_path__ + "img/mtt_2.4.ea2e6065.png";